import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/spaces")({
  component: () => <Outlet />,
});
